import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { UserResponseDto, UserRoleResponseDto } from '@api';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { GlobalDataService } from '@core-service';
import { SharedVersionComponent } from '@shared';

import { CoreStorageService, MenuItem, SidebarMenuComponent } from 'pn-core-code';

@Component({
  selector: "app-menu",
  standalone: true,
  imports: [SidebarMenuComponent, SharedVersionComponent],
  templateUrl: "./app-menu.component.html",
  styleUrl: "./app-menu.component.scss",
})
export class AppMenuComponent implements OnInit, OnDestroy {
  userProfile: any;
  menus: MenuItem[] = [];
  user: UserResponseDto = {} as UserResponseDto;
  userGroup: string;
  locationId: string;

  focusUserGroupSub: Subscription;
  constructor(
    private localize: LocalizeRouterService,
    private global: GlobalDataService,
    private translateService: TranslateService,
    private storage: CoreStorageService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    if (this.focusUserGroupSub) {
      this.focusUserGroupSub.unsubscribe();
    }

    this.focusUserGroupSub = this.global.focusUserGroupSubject.subscribe((data) => {
      if (!data) {
        this.global.getFocusUserGroup();
      } else {
        const tempFocusUserGroup = this.storage.getItem("focus_user_group");
        if (tempFocusUserGroup) {
          const data = JSON.parse(tempFocusUserGroup);
          this.userGroup = data.userGroup;
          this.locationId = data.branch?.id;
        } else {
          const userGroupData = JSON.parse(data);
          this.locationId = data.branch?.id;
          this.userGroup = userGroupData.userGroup;
        }

        this.renderMenu();
      }
    });
    this.translateService.onLangChange.subscribe((data) => this.renderMenu());
  }

  ngOnInit() {
    const report = this.route.snapshot.paramMap.get("report");
    console.log("report", report);
  }

  ngOnDestroy(): void {
    this.focusUserGroupSub && this.focusUserGroupSub.unsubscribe();
  }

  renderMenu() {
    console.log("renderMenu locationId", this.locationId);
    console.log("url ---> 67", this.router.url);
    let reportUrl = this.router.url.split("/")[2];
    console.log("reportUrl ", reportUrl);

    setTimeout(() => {
      if (reportUrl === "report") {
        if (this.userGroup === UserRoleResponseDto.UserGroupEnum.ExecutiveWpn || this.userGroup === UserRoleResponseDto.UserGroupEnum.CentralStaffWpn) {
          this.menus = this.getMenuReport();
        }
      } else {
        console.log("no reportUrl ", this.userGroup);
        switch (this.userGroup) {
          case UserRoleResponseDto.UserGroupEnum.ExecutiveWpn:
            this.menus = this.locationId ? this.getMenuLocation() : this.getMenuWPN();
            break;
          case UserRoleResponseDto.UserGroupEnum.CentralStaffWpn:
            this.menus = this.locationId ? this.getMenuLocation() : this.getMenuWPN();
            break;
          case UserRoleResponseDto.UserGroupEnum.BranchStaffWpn:
            this.menus = this.locationId ? this.getMenuLocation() : [];
            break;
          case UserRoleResponseDto.UserGroupEnum.BranchExecutiveFranchise:
            this.menus = this.locationId ? this.getMenuFranchise() : [];
            break;
          case UserRoleResponseDto.UserGroupEnum.BranchStaffFranchise:
            this.menus = this.locationId ? this.getMenuFranchise() : [];
            break;
        }
      }

      this.menus = this.menus.map((m) => {
        if (m.items && m.items.length > 0) {
          m.items.map((i) => {
            if (i.routerLink) {
              i.routerLink = this.localize.translateRoute(i.routerLink);
            }
            return i;
          });
        }
        return m;
      });
    }, 0);
  }

  getMenuWPN(): MenuItem[] {
    return [
      {
        label: "middlePrice.title",
        items: [{ label: "middlePrice.title", icon: "fa fa-tag", routerLink: ["/middle-price"] }],
      },
      {
        label: "purchasePrice.title",
        items: [
          // { label: 'purchasePrice.title', icon: 'fa fa-tag', routerLink: ['/purchase-price'] },
          { label: "purchaseList", icon: "pi pi-list", routerLink: ["/purchase"] },
          { label: "weighing.weighingTitle", icon: "fa fa-weight-scale", routerLink: ["/bulk-loading"] },
        ],
      },
      {
        label: "product",
        items: [
          { label: "productsForPurchase", icon: "pi pi-objects-column", routerLink: ["/product"] },
          { label: "productCategory", icon: "pi pi-microsoft", routerLink: ["/product-category"] },
          { label: "countingUnit", icon: "pi pi-clone", routerLink: ["/unit"] },
          { label: "miscellaneousProducts", icon: "fa fa-table-cells-large", routerLink: ["/miscellaneous-products"] },
        ],
      },
      {
        label: "member",
        items: [
          { label: "member", icon: "pi pi-users", routerLink: ["/member"] },
          { label: "memberTier.memberTierTitle", icon: "pi pi-star-fill", routerLink: ["/member-tier"] },
        ],
      },
      {
        label: "memberFranchiseWpn",
        items: [
          { label: "branchWpn", icon: "fa fa-shop", routerLink: ["/branch-wpn"] },
          { label: "franchise", icon: "fa fa-store", routerLink: ["/franchise"] },
          { label: "licenseFranchise", icon: "fa fa-file-signature", routerLink: ["/license-franchise"] },
          { label: "franchiseTier.franchiseTierTitle", icon: "pi pi-star-fill", routerLink: ["/franchise-tier"] },
          { label: "bank", icon: "fa fa-building-columns", routerLink: ["/bank"] },
        ],
      },
      {
        label: "mainSettings.settings",
        items: [
          {
            label: "mainSettings.tablet",
            icon: "fa fa-tablet-screen-button",
            routerLink: ["/set-up-wallpaper/tablet"],
          },
          { label: "mainSettings.admin", icon: "fa fa-desktop", routerLink: ["/set-up-wallpaper/admin"] },
          { label: "termAndConRegistration.title", icon: "pi pi-shield", routerLink: ["/terms-and-condition"] },
        ],
      },
      {
        label: "userManagement.title",
        items: [
          { label: "userManagement.rolePermission", icon: "pi pi-shield", routerLink: ["/role"] },
          { label: "userManagement.userAccount", icon: "pi pi-user-plus", routerLink: ["/user"] },
        ],
      },
    ];
  }

  getMenuFranchise(): MenuItem[] {
    console.log("getMenuFranchise 12345ce", this.user);
    if (this.userGroup && this.userGroup === UserRoleResponseDto.UserGroupEnum.BranchExecutiveFranchise) {
      return [
        {
          label: "purchase",
          items: [
            { label: "purchasePrice.title", icon: "fa fa-tag", routerLink: [`/${this.locationId}/purchase-price`] },
            { label: "purchaseList", icon: "pi pi-list", routerLink: [`/${this.locationId}/purchase`] },
            {
              label: "weighing.weighingTitle",
              icon: "fa fa-weight-scale",
              routerLink: [`/${this.locationId}/bulk-loading`],
            },
          ],
        },
        // {
        //   label: 'memberFranchiseWpn',
        //   items: [
        //     { label: 'franchise', icon: 'fa fa-shop', routerLink: [`/${this.locationId}/franchise`] }
        //   ]
        // },
        // {
        //   label: 'userManagement.title',
        //   items: [
        //     // { label: 'userManagement.rolePermission', icon: 'pi pi-shield', routerLink: ['/role'] },
        //     { label: 'userManagement.userAccount', icon: 'pi pi-user-plus', routerLink: ['/user'] },
        //   ]
        // },
      ];
    } else {
      return [
        {
          label: "purchase",
          items: [
            { label: "purchasePrice.title", icon: "fa fa-tag", routerLink: [`/${this.locationId}/purchase-price`] },
            { label: "purchaseList", icon: "pi pi-list", routerLink: [`/${this.locationId}/purchase`] },
            {
              label: "weighing.weighingTitle",
              icon: "fa fa-weight-scale",
              routerLink: [`/${this.locationId}/bulk-loading`],
            },
          ],
        },
        // {
        //   label: 'memberFranchiseWpn',
        //   items: [
        //     { label: 'franchise', icon: 'fa fa-shop', routerLink: [`/${this.locationId}/franchise`] }
        //   ]
        // }
      ];
    }
  }

  getMenuLocation(): MenuItem[] {
    return [
      {
        label: "purchase",
        items: [
          { label: "purchasePrice.title", icon: "fa fa-tag", routerLink: [`/${this.locationId}/purchase-price`] },
          { label: "purchaseList", icon: "pi pi-list", routerLink: [`/${this.locationId}/purchase`] },
          {
            label: "weighing.weighingTitle",
            icon: "fa fa-weight-scale",
            routerLink: [`${this.locationId}/bulk-loading`],
          },
        ],
      },
    ];
  }

  getMenuReport(): MenuItem[] {
    return [
      {
        label: "report.title",
        items: [
          { label: "report.reportPurchased", icon: "fa-regular fa-file-lines", routerLink: ["/report/report-purchase"] },
          { label: "weighing.reportWeighingTitle", icon: "fa-regular fa-file-lines", routerLink: ["/report/report-bulk-loading"] },
          { label: "report.reportRegisterMember", icon: "fa-regular fa-file-lines", routerLink: ["/report/report-register-member"] },
          { label: "report.reportRegisterFranchise", icon: "fa-regular fa-file-lines", routerLink: ["/report/report-register-franchise"] },
          { label: "report.listOfActiveMembersFranchises", icon: "fa-regular fa-file-lines", routerLink: ["/report/report-active-members-and-franchise"] },
          { label: "report.inventoryReport", icon: "fa-regular fa-file-lines", routerLink: ["/report/report-inventory"] },
        ],
      },
    ];
  }
}
